<template>
    <div class="pop_overay agree">
        <div class="pop_cont">
            <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
            <div class="text_2">
                <div class="agree_top">
                  <h3>개인정보 제3자 제공 동의</h3>
                  <p>스탬프 획득을 위해서는<br>개인정보 제3자 제공 동의가 필요합니다.</p>
                </div>
                <div class="agree_pop">
                  <div class="notice">Notice</div>
                  <div class="agree_desc">
                    • 제공받는 기관<br>
                    <span>{{ mainAgreeInfo.agency || '' }}</span><br/>
                    • 수집/이용 목적<br>
                    <span>{{ mainAgreeInfo.period || '' }}</span><br/>
                    • 제공하는 개인 정보 항목<br>
                    <span>{{ mainAgreeInfo.purpose || '' }}</span><br/>
                    • 보유기간<br>
                    <span>{{ mainAgreeInfo.info_data || '' }}</span><br/>
                    • 개인정보 제3자 제공 현황 <span class="link" @click="agreeDetail">자세히보기</span>
                  </div>
                </div>
                <div class="check">
                  <input type="checkbox" id="personal"  name="personal" v-model="personal"> <label for="personal">개인정보 제 3자 제공 동의합니다.</label>
                </div>
            </div>
            <button
              class="type1"
              @click="closeBtn"
            >
              닫기
            </button>
            <button
              class="type2"
              :class="!personal ? 'btnBlock' : ''"
              @click="agreeClick"
            >
              시작하기
            </button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import * as appEvent from '@/assets/js/app_event.js'
export default {
  name: 'PopupAgree',
  components: {
  },
  data () {
    return {
      personal: false,
      btnBlock: true
    }
  },
  computed: {
    ...mapState(['mainAgreeInfo', 'agreeStatus'])
  },
  methods: {
    closeBtn () {
      if (this.$route.query.popup === 'on') {
        this.$router.go(-1)
      }
      this.$store.state.agreePopupClick = false
    },
    agreeClick () {
      if (this.$route.query.popup === 'on') {
        this.$router.go(-1)
      }
      this.$store.dispatch('loadAgreeStatus', 'TRUE')
      this.$emit('tourStart')
    },
    agreeDetail () {
      const url = 'https://app.tranggle.com/front/terms/provision/?web_status=web'
      appEvent.externalLinks(url)
    }
  },
  watch: {
    $route (to, from) {
      if (from.query.popup === 'on') {
        this.$store.state.agreePopupClick = false
      }
    },
    mainAgreeInfo () {
      console.log(this.mainAgreeInfo)
    },
    agreeStatus () {
      this.closeBtn()
    }
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
